export default ['None', 'Low', 'Medium', 'High', 'Critical'];
